<template lang="pug">
  .branding
    .first
      Logo(:brand="brand")
    .logo
      Logo(:brand="sponsor")
    .presented
      Logo(:brand="lab")

</template>
<script>
import Logo from '@/components/Logo'


export default {
  components: {
    Logo
  },
  props: {
    sponsor: {
      type: Object
    },
    brand: {
      type: Object
    },
    lab: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
  .branding{
    display: grid;
    align-items: center;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    padding: 0.5rem 1rem;
    font-family: 'Open Sans', sans-serif;
    @media (max-width: 450px){
      grid-template-columns: repeat(2, 1fr);
    }
    .first{
      display: flex;
      justify-content: flex-start;
    }
    .logo{
      display: flex;
      justify-content: center;
    }
    .presented{
      display: flex;
      justify-content: flex-end;
      @media (max-width: 450px){
        display: none;
      }
    }
    h3{
      text-transform: uppercase;
      font-size: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
    }
  }
</style>

